import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class EmailService {
  constructor(private http: HttpClientService) {}

  public postEmail(person_id, email): Observable<any> {
    let body = {
      active: true,
      email: email,
    };
    return this.http
      .post("/api/persons/" + person_id + "/email", body)
      .pipe(tap((_) => console.log("EmailService.postEmail: Ok.")));
  }

  public deleteEmail(email_id) {
    return this.http.delete("/api/email/" + email_id).pipe(tap((_) => console.log("EmailService.deleteEmail: Ok.")));
  }

  public updateEmail({ email_id, info = undefined, category = undefined, active = undefined }) {
    let params = { info, category, active };
    return this.http
      .put("/api/email/" + email_id, params)
      .pipe(tap((_) => console.log("EmailService.updateEmail: Ok.")));
  }

  public putPrincipalEmail(person_id, id): Observable<any> {
    return this.http
      .put("/api/persons/" + person_id + "/email/" + id + "/principal_email", {})
      .pipe(tap((_) => console.log("EmailService.putPrincipalEmail: Ok.")));
  }
}
